import { render } from "./PersonPrerenderSnapshot.vue?vue&type=template&id=68b0c59f&scoped=true"
import script from "./PersonPrerenderSnapshot.vue?vue&type=script&lang=js"
export * from "./PersonPrerenderSnapshot.vue?vue&type=script&lang=js"

import "./PersonPrerenderSnapshot.vue?vue&type=style&index=0&id=68b0c59f&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-68b0c59f"]])

export default __exports__